<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="untitled-1">
<div class="calibre1">
<p class="normal-310-0-override2"><span class="no-style-override9"><br class="calibre1"/></span></p>
</div>
<div class="calibre1">
<p class="normal-310-0-override"><span class="no-style-override9"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override9"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override9"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override9"><br class="calibre1"/></span></p>
<p class="normal-310-0-override"><span class="no-style-override11">For Vincenzo, Roberto, Giovanni, and the entire New England clan, scattered now to time and distance and the four winds </span></p>
<p class="calibre3" id="calibre_pb_12"></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?673f85d4